import { render, staticRenderFns } from "./setQCookie.vue?vue&type=template&id=53c01ca5&scoped=true&"
import script from "./setQCookie.vue?vue&type=script&lang=js&"
export * from "./setQCookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c01ca5",
  null
  
)

export default component.exports